
import { SyncDataUnitToPen, IUnitToPen } from 'shared/api/api';
import { GenActionFactoryName } from 'shared/helpers/redux-helpers';
import actionCreatorFactory from 'typescript-fsa';
import * as types from './types';

const actionCreator = actionCreatorFactory(GenActionFactoryName('unitToPenData'));
export const getSyncData = actionCreator.async<{siteId: string; activeSiteId?: string }, SyncDataUnitToPen>(types.GET_UnitToPenData);
export const saveData = actionCreator.async< IUnitToPen, string>(types.SAVE_UnitToPen);
